/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: fetch,post
 * note:
 *  - HTTP POSTメッセージを送信する
 *  - オフラインかどうかを確認する
 * sample:
 *  - すべてのプロジェクト
 * :ZNOTE:
 */

import {getFetch} from './env';


let isOnlineFlag = true;
export const getOnlineFlag = () => isOnlineFlag;


/**
 * make RESTful API call
 * @param method {String} - 'GET' or 'POST'
 * @param requestUrl {String} - url connected with the endpoint defined above.
 * @param payload {Object} - request body.
 * @param headers - header params.
 * @param mode
 * @param jsonize
 * @return {Promise<*>}
 */
export const makeApiCall = async ({method, requestUrl, payload = undefined, headers = undefined, mode = 'cors', jsonize = true}: any) => {
  // logger.debug('make API call to AWS API Gateway');
  const fetch: any = getFetch();

  const body: any = (payload && jsonize) ? JSON.stringify(payload) : (payload) || undefined;
  try {
    const response: any = await fetch(requestUrl, {
      method,
      body,
      headers,
      mode
    });
    let success = false;
    if (response.status >= 200 && response.status < 300) {
      success = true;
      if (!jsonize) {
        return response;
      }
    }

    const responseJson = await response.json();
    if (success) {
      return responseJson;
    } else {
      const err = Object.assign({status: response.status, statusText: response.statusText}, responseJson);
      throw new Error(JSON.stringify(err));
    }
  } catch (e) {
    console.log('error');
    console.log(e);
  }
};

export const createOptions = (idToken: string|undefined, url: string, header: any|undefined, payload: any = undefined) => {
  const options: any = {
    method: 'POST',
    requestUrl: url,
    headers: {'Content-Type': 'application/json'},
    mode: 'cors'
  };
  if (header !== undefined) {
    Object.assign(options.headers, header);
  }
  if (payload !== undefined) {
    options.payload = payload;
  }
  if (idToken !== undefined) {
    options.headers.Authorization = `Bearer ${idToken}`;
  }
  return options;
};


const checkOnlineStatus = async () => {
  try {
    const fetch: any = getFetch();
    const online = await fetch('/isconnected.txt');
    return online.status >= 200 && online.status < 300; // either true or false
  } catch (err) {
    return false; // definitely offline
  }
};

/**
 * 定期的にインターネットコネクティビティをチェックする
 * @param interval
 */
export const startOfflineCheck = async (interval=60000) => {
  isOnlineFlag = await checkOnlineStatus();
  setInterval(async () => {
    isOnlineFlag = await checkOnlineStatus();
  }, interval);
};
